import React from 'react';
import { Container, BlobWrapper, Blob, headingClassName, descriptionClassName } from './Spinner.styles';
import { SpinnerProps } from './types';

export const Spinner = ({
  size = 1.5,
  className,
  blobWrapperClassName,
  blobClassName,
  heading,
  description,
  ...props
}: SpinnerProps): JSX.Element => (
  <Container className={className} data-testid="default-loading-ui" {...props}>
    {heading && <p className={headingClassName}>{heading}</p>}
    {description && <p className={descriptionClassName}>{description}</p>}
    <BlobWrapper className={blobWrapperClassName}>
      <Blob className={blobClassName} size={size} />
      <Blob className={blobClassName} size={size} />
    </BlobWrapper>
  </Container>
);
